import React from "react";
import { Crown, PenTool, Magnet, Bot, Handshake, Cog } from "lucide-react";
import CTAButton from "./CTAButton";

const BUILDS = [
  {
    icon: <Crown className="w-6 h-6" />,
    title: "AI-Powered Expert Positioning",
    desc: "Position your expertise so premium buyers instantly understand why they should choose you over cheaper, louder alternatives.",
  },
  {
    icon: <PenTool className="w-6 h-6" />,
    title: "Authority Content Engine",
    desc: "Create content that builds trust, visibility and demand — using AI-assisted systems, not endless manual effort.",
  },
  {
    icon: <Magnet className="w-6 h-6" />,
    title: "Predictable Lead Generation System",
    desc: "Convert attention into qualified leads with structured lead-capture mechanisms — not just vanity views and empty engagement.",
  },
  {
    icon: <Bot className="w-6 h-6" />,
    title: "Automated Nurturing Engine",
    desc: "Use WhatsApp, email, AI and follow-up systems to nurture prospects consistently, without you being the bottleneck.",
  },
  {
    icon: <Handshake className="w-6 h-6" />,
    title: "High-Ticket Client Acquisition System",
    desc: "Move qualified prospects from attention to conversation, and from conversation to a premium purchase decision.",
  },
  {
    icon: <Cog className="w-6 h-6" />,
    title: "AI Business Operating System",
    desc: "Build repeatable systems that reduce dependency on your daily manual effort — so growth doesn't collapse when you take a break.",
  },
];

export default function WhatYouBuild() {
  return (
    <section className="relative z-10 px-4 py-10 md:py-14">
      <div className="max-w-7xl mx-auto">
        <p className="text-center text-[#C4FF3D] uppercase tracking-[0.28em] text-[11px] md:text-xs font-bold mb-3">
          What You'll Build Inside The Workshop
        </p>
        <h2 className="display-font text-center text-3xl md:text-5xl font-extrabold leading-tight mb-4">
          <span className="text-white">Six Systems That Turn Expertise Into A</span>{" "}
          <span className="lime-box">Client-Acquisition Machine.</span>
        </h2>
        <p className="text-center text-white/65 max-w-3xl mx-auto mb-14">
          Not theory. Not motivation. Real, connected systems that map directly to how premium buyers actually decide, book and pay.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {BUILDS.map((b, i) => (
            <div key={b.title} className="feature-card p-6 md:p-7 relative overflow-hidden">
              <div className="absolute top-4 right-5 text-[#C4FF3D]/25 display-font text-4xl font-extrabold">
                0{i + 1}
              </div>
              <div className="w-12 h-12 rounded-xl bg-[#0a0f0a] border border-[rgba(196,255,61,0.3)] flex items-center justify-center text-[#C4FF3D] mb-5">
                {b.icon}
              </div>
              <h3 className="text-white text-lg md:text-xl font-bold mb-2.5 leading-snug">
                {b.title}
              </h3>
              <p className="text-white/65 text-sm md:text-[15px] leading-relaxed">{b.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 flex justify-center">
          <CTAButton source="what_you_build" size="lg">
            Give Me The AI Growth System
          </CTAButton>
        </div>
      </div>
    </section>
  );
}
